import { Check, Minus, X, Zap, type LucideIcon } from "lucide-react";
import { type ReactElement } from "react";

import { cn } from "../utils/cn";

export type SkillMatchType =
  | "must-met"
  | "must-missing"
  | "should-met"
  | "should-missing"
  | "other";

const MAP: Record<SkillMatchType, { classes: string; icon: LucideIcon | null }> = {
  "must-met": {
    classes: "bg-[var(--skill-must-met-bg)] text-[var(--skill-must-met-fg)]",
    icon: Check,
  },
  "must-missing": {
    classes: "bg-[var(--skill-must-missing-bg)] text-[var(--skill-must-missing-fg)]",
    icon: X,
  },
  "should-met": {
    classes: "bg-[var(--skill-should-met-bg)] text-[var(--skill-should-met-fg)]",
    icon: Zap,
  },
  "should-missing": {
    classes: "bg-[var(--skill-should-missing-bg)] text-[var(--skill-should-missing-fg)]",
    icon: Minus,
  },
  other: {
    classes: "bg-[var(--skill-other-bg)] text-[var(--skill-other-fg)]",
    icon: null,
  },
};

export interface SkillTagProps {
  type: SkillMatchType;
  label: string;
  className?: string;
}

export function SkillTag({ type, label, className }: SkillTagProps): ReactElement {
  const cfg = MAP[type];
  const Icon = cfg.icon;
  return (
    <span
      className={cn(
        "inline-flex items-start gap-1.5 rounded-sm text-left py-0.5 pl-2 pr-2.5 text-xs font-medium",
        cfg.classes,
        className,
      )}
    >
      {Icon && <Icon size={12} strokeWidth={2.5} className="mt-0.5 shrink-0" />}
      {label}
    </span>
  );
}
